import React, {memo} from 'react';
import styles from './FJUndo.module.less';
import InlineSVG from "react-inlinesvg";
import undoIcon from "../../../icon/undo.svg";
import redoIcon from "../../../icon/redo.svg";
import classNames from "classnames";
import FJUtil from "../../../util/FJUtil";
import FJLocalStore from "../../../store/FJLocalStore";

function FJUndo(props) {

  let {hasUndo, hasRedo, undo, redo, ealogClick} = props;
  let undoClass = classNames(styles.button, 'u-tooltip-bottom', hasUndo ? '' : styles.disabled);
  let redoClass = classNames(styles.button, 'u-tooltip-bottom', styles.margin, hasRedo ? '' : styles.disabled);
  let {undoTitle, redoTitle} = getTitles();

  function getTitles() {
    return FJUtil.getOSInfo().name === 'Mac' ? {
      undoTitle: FJLocalStore._('undo-mac'),
      redoTitle: FJLocalStore._('redo-mac'),
    } : {
      undoTitle: FJLocalStore._('undo-win'),
      redoTitle: FJLocalStore._('redo-win'),
    }
  }

  return (
    <div className={styles.undo_box}>
      <div className={undoClass} onClick={() => {
				if (hasUndo) {
					ealogClick('click');
					undo();
				}
			}} tooltip={undoTitle}>
        <InlineSVG src={undoIcon}/>
      </div>
      <div className={redoClass} onClick={() => {
				if (hasRedo) {
					ealogClick('click');
					redo();
				}
			}} tooltip={redoTitle}>
        <InlineSVG src={redoIcon}/>
      </div>
    </div>
  );
}

export default memo(FJUndo);
